export default "__VITE_ASSET__P0w_EcGg__"